// @flow

import HomepageThingsToDo from './things-to-do'

export default HomepageThingsToDo
